<form [formGroup]="userdataForm" class="standard-form" (ngSubmit)="onSubmit()">
  <!-- <mat-form-field appearance="fill">
  <mat-label>{{'FirstName' | translate }}</mat-label>
  <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
  <mat-error *ngIf="userdataForm.controls['firstName'].hasError('minlength') && !userdataForm.controls['firstName'].hasError('required')">
    {{'FieldRequiredMoreThanTwoChar' | translate }}
  </mat-error>
  <mat-error *ngIf="userdataForm.controls['firstName'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
  </mat-error>
</mat-form-field> -->
<br>
  <!-- <mat-form-field appearance="fill">
  <mat-label>{{'LastName' | translate }}</mat-label>
  <input matInput formControlName="lastName" placeholder="Wprowadź nazwisko...">
  <mat-error *ngIf="userdataForm.controls['lastName'].hasError('minlength') && !userdataForm.controls['lastName'].hasError('required')">
    {{'FieldRequiredMoreThanTwoChar' | translate }}
  </mat-error>
  <mat-error *ngIf="userdataForm.controls['lastName'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
  </mat-error>
</mat-form-field> -->

<mat-form-field appearance="fill">
  <mat-label>{{'PhoneNr' | translate}}</mat-label>
  <input matInput formControlName="customerIdentifier" placeholder="Enter the phone number..." pattern="^[1-9][0-9]*$">
  <mat-icon matSuffix>phone</mat-icon>
  <!-- <mat-hint>Include area code</mat-hint> -->
  @if (userdataForm.controls['customerIdentifier'].hasError('minlength') && !userdataForm.controls['customerIdentifier'].hasError('required')) {
    <mat-error>
      {{'FieldRequiredMoreThanEightChar' | translate}}
    </mat-error>
  }
  @if (userdataForm.controls['customerIdentifier'].hasError('required')) {
    <mat-error [innerHtml]="'FieldRequired' | translate">
    </mat-error>
  }
</mat-form-field>
<br>
  <!-- <br>
  <mat-form-field appearance="fill">
    <mat-label>{{'DocumentNr' | translate}}</mat-label>
    <input matInput formControlName="documentNr" placeholder="Wprowadź serię i numer z dowodu osobistego...">
    <mat-error *ngIf="userdataForm.controls['documentNr'].hasError('minlength') && !userdataForm.controls['documentNr'].hasError('required')">
      {{'FieldRequiredMoreThanFiveChar' | translate}}
    </mat-error>
    <mat-error *ngIf="userdataForm.controls['documentNr'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
    </mat-error>
  </mat-form-field> -->
  <br>
    <div class="cbx-accept">
      <mat-checkbox formControlName="regulationAccept"
        class="example-margin">
        {{'AcceptRules' | translate }}
      </mat-checkbox>
      <br><br>
      <mat-checkbox formControlName="dataProcessAccept"
        class="example-margin">
        {{'AcceptPersonalData' | translate }}
      </mat-checkbox><br><br>
      <span>{{'AcceptPrivacyRules' | translate}}
      </span>
    </div>
    <!-- <button (click)="executeImportantAction()">Important action</button> -->
    <br>
      <div class="form-btn-wrapper">
        <button mat-raised-button color="primary" type="submit" [disabled]="!userdataForm.valid">
          @if (loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{'Next' | translate }}
        </button>
      </div>
    </form>